export default {
  create_a_survey: '建立新問卷',
  from_empty: '空白問卷',
  from_template: '精選範本',
  responses: '回覆',
  surveyStatus: {
    PUBLIC: '公開',
    PRIVATE: '密碼保護',
    OFF: '關閉',
    ENDED: '到期關閉',
    COMING_SOON: '即將公開',
    REPLY_FULL: '額滿關閉'
  },
  title: '標題',
  status: '問券狀態',
  allStatus: '全部狀態',
  createtime: '建立日期',
  reply_count: '回覆數',
  table: {
    show: '顯示',
    to: '至',
    unit: '筆',
    total: '共',
    dataText: '資料',
    comma: '，',
    selectTag: '選擇標籤'
  },
  menu: {
    edit: '編輯',
    preview: '預覽',
    move: '移動',
    duplicate: '複製',
    share: '問卷連結',
    createSlaveSurvey: '建立子問卷',
    review: '問卷回覆',
    chart: '統計圖表'
  },
  orderFilter: {
    createtime: '最新建立日期',
    updatetime: '更新時間',
    reply_time_latest: '最新回覆時間',
    reply_count: '最多回覆'
  },
  from: '從',
  to: '到',
  startDate: '開始日期',
  endDate: '結束日期',
  chips: {
    slave: '子問卷',
    master: '母問卷',
    pro: 'PRO'
  }
};
